import { List, Create, Edit, View, SalesReturn } from "../Components/index.js";

export default [
    { path: "/voucher/store/purchase", component: List, name: "voucher.store.purchase" },
    { path: "/voucher/store/purchase/create", component: Create, name: "voucher.store.purchase.create" },
    { path: "/voucher/store/sales-return/create", component: SalesReturn, name: "voucher.store.sales.return.create" },
    { path: "/voucher/store/purchase/:id/edit", component: Edit, name: "voucher.store.purchase.edit" },
    { path: "/voucher/store/purchase/:id/view", component: View, name: "voucher.store.purchase.view" }
];
